import { useEffect } from 'react';
import ArticlePageTemplate from '@/components/feature/ArticlePageTemplate';
import { articles } from '@/mocks/articleContent';

export default function BasetaoCoupon() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return <ArticlePageTemplate article={articles[3]} />;
}